import {SideBaseModule} from "../SideBaseModule";
import {HeightLocationModule} from "../HeightLocationModule";

export const ModulesFilterData = [
    {
        "idFromColumnFilter": "name",
        "id": "name",
    },
    {
        "idFromColumnFilter": "groupName",
        "id": "groupName",
    },
    {
        "idFromColumnFilter": "width",
        "id": "width",
    },
    {
        "idFromColumnFilter": "height",
        "id": "height",
    },
    {
        "idFromColumnFilter": "depth",
        "id": "depth",
    },
    {
        "idFromColumnFilter": "minWidth",
        "id": "minWidth",
    },
    {
        "idFromColumnFilter": "minHeight",
        "id": "minHeight",
    },
    {
        "idFromColumnFilter": "minDepth",
        "id": "minDepth",
    },
    {
        "idFromColumnFilter": "maxWidth",
        "id": "maxWidth",
    },
    {
        "idFromColumnFilter": "maxHeight",
        "id": "maxHeight",
    },
    {
        "idFromColumnFilter": "maxDepth",
        "id": "maxDepth",
    },
    {
        "idFromColumnFilter": "sideBaseModule",
        "id": "sideBaseModule",
        "filterFn": (value, filterValue) => SideBaseModule[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "heightLocation",
        "id": "heightLocation",
        "filterFn": (value, filterValue) => HeightLocationModule[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
]